import { useQuery } from "@apollo/client/react";
import GET_LG_EMAIL_TEMPLATES from "../../queries/contentful/getLgEmailTemplates";
import { contentfulClient } from "../../contentfulClient";

interface Response {
  lgEmailTemplatesCollection?: {
    items?: Array<{
      id: string;
      title: string;
      content: string;
      templateType: "recipient" | "issuer";
    }>;
  };
}

export const useLgEmailTemplates = () => {
  const { data, error, loading, refetch } = useQuery<Response>(
    GET_LG_EMAIL_TEMPLATES,
    {
      client: contentfulClient,
    }
  );
  return {
    lgTemplates: data?.lgEmailTemplatesCollection?.items ?? [],
    error,
    loading,
    refetch,
  };
};
